module.exports = __webpack_public_path__ + "img/ch18_01_研究院日常.739ff6c5.jpg";